import { useAsyncStorage } from "@react-native-async-storage/async-storage";

/**
 * Hook to store the initial screen loaded when the user started the app. If the
 * user's not logged in, Chord will redirect back to the login screen but keep
 * the initial screen here to redirect back after (see useNextScreen).
 */
export const useInitialScreenStorage = () => useAsyncStorage("initialScreen");
